import { render } from "./ReturnCreation.vue?vue&type=template&id=46ba2440"
import script from "./ReturnCreation.vue?vue&type=script&lang=js"
export * from "./ReturnCreation.vue?vue&type=script&lang=js"

import "./ReturnCreation.vue?vue&type=style&index=0&id=46ba2440&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__